import {
  GET_BILLING_ADDRESS_DONE
} from '../actions';
import pick from 'lodash/pick';
const initState = {
  address: '',
  city: '',
  country: '',
  phone: '',
  state: ''
}

export default function billingAddress(state = initState, action) {
  switch(action.type) {
    case GET_BILLING_ADDRESS_DONE:
    return { ...state, ...pick(action.payload, Object.keys(initState)) };
    default: 
      return state;
  }
}